<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Maestro
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span>Maestro</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="showModalAddMaquina()" mdbWavesEffect size="sm">
        Agregar
      </button>
  <button type="button" mdbBtn color="info" (click)="showModalCargaMasiva()" mdbWavesEffect size="sm" *ngIf="canAddClientesMasivos">
        Carga Masiva por Archivo
      </button>
    </div>

    <form autocomplete="off" [formGroup]="formHeader">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" required
              #rutcliente formControlName="rutCliente" formatRut />
            <label for="rutcliente">Rut cliente</label>
            <!-- <div *ngIf="
                formHeader.get('rutCliente').invalid &&
                (formHeader.get('rutCliente').dirty ||
                formHeader.get('rutCliente').touched)
                ">
              <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                Ingrese rut cliente
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarcliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents" *ngIf="cliente">
            {{ cliente.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <input value="" type="text" id="nplaca" class="form-control" placeholder="AAAADF" #nplaca
              formControlName="nroPlaca" />
            <label for="nplaca">N° Placa</label>
            <!-- <div *ngIf="
                formHeader.get('nroPlaca').invalid &&
                (formHeader.get('nroPlaca').dirty ||
                formHeader.get('nroPlaca').touched)
                ">
              <mdb-error *ngIf="formHeader.get('nroPlaca').hasError('required')">
                Ingrese n° placa
              </mdb-error>
            </div> -->
          </div>
        </div>
      </div>

      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="familia"></mdb-select>
            <label>Familia</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Vendedor" formControlName="vendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsProveedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Proveedor" formControlName="proveedor"></mdb-select>
            <label>Proveedor</label>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado" formControlName="estado"></mdb-select>
            <label>Estado</label>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="listaRubro"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 30%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>


<div class="card mb-2 wow stickyContador" *ngIf="listaMaquinas?.length > 0">
  <div class="card-body d-sm-flex justify-content-between p-1">
    <div class="d-flex align-items-center">
      <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
        (click)="showModalEditMaquina(SelectMaquina)" placement="right" [disabled]="estadoItem === true">
        <mdb-icon fas icon="pen"></mdb-icon>
      </button>
      <button mdbBtn type="button" color="info" mdbWavesEffect class="btn btn-sm" size="sm"
        (click)="showModalAsignar(SelectMaquina)" placement="right" [disabled]="EstadoMaquina === InActButton">
        Asignar
      </button>
      <button mdbBtn type="button" color="info" mdbWavesEffect class="btn btn-sm" size="sm"
        (click)="showModalModalDarDeBaja(SelectMaquina)" placement="right" [disabled]="EstadoMaquina === InActButton">
        Inactivar
      </button>
    </div>

    <div class="card-body d-sm-flex p-1 justify-content-end">

      <div class="form-group row contador">
        <!-- <label for="ContEq" class="col-sm-3 col-form-label fontContador text-right font-weight-bold" size="sm">página {{ PagPosActual }} </label> -->
        <div class="col-sm-2 fontContador" size="sm">
          <input type="text" class="form-control fontContador text-center" id="inputAct" placeholder="activos"
            value="{{totalActivos | numerico}}">
          <div class="text-center">
            <label for="Act" class="col-form-label center font-weight-bold" size="sm">Activos</label>
          </div>
        </div>
        <div class="col-sm-2 fontContador">
          <input type="text" class="form-control fontContador text-center" id="inputIn" placeholder="inactivos"
            value="{{totalInactivos | numerico}} ">
          <div class="text-center">
            <label for="Inact" class="col-form-label center font-weight-bold" size="sm">Inactivos</label>
          </div>
        </div>
        <div class="col-sm-2 fontContador">
          <input type="text" class="form-control fontContador text-center" id="inputTotalRegistros" placeholder="Total"
            value="{{totalRegistrosPos | numerico}}">
          <div class="text-center">
            <label for="TotalRegis" class="col-form-label text-center font-weight-bold" size="sm">Total</label>
          </div>
        </div>
      </div>

      <div class="d-sm-flex p-1">
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
          (click)="downloadExcelPdf('XLS')">
          Excel
        </button>
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
          (click)="downloadExcelPdf('PDF')">
          PDF
        </button>
      </div>

    </div>

  </div>
</div>

<section infinite-scroll (scrolled)="onScrollDown($event)">
  <div class="card mb-2 wow">
    <div class="card-body" *ngIf="listaMaquinas">

      <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

      <div class="">

        <table class="table TablePrincipal table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2 stickyTable">
            <tr>
              <th scope="col" style="width: 50px;">Mov.</th>
              <th scope="col" style="width: 100px;">N° Placa</th>
              <th scope="col" style="width: 75px;">Marca</th>
              <th scope="col" style="width: 75px;">Modelo</th>
              <th scope="col" style="width: 80px;">F. Asignación</th>
              <th scope="col">Ubicación</th>
              <th scope="col" style="width: 100px;">Rut</th>
              <th scope="col">Cliente</th>
              <!-- <th scope="col">Cod. Sucursal</th>
              <th scope="col">Sucursal</th> -->
              <th scope="col">Dir. Asignada</th>
              <th scope="col" style="width: 80px;">Comuna</th>
              <th scope="col" style="width: 75px;">Cod. Vend.</th>
              <th scope="col">Vendedor</th>
              <th scope="col" style="width: 75px;">Estado</th>
              <th scope="col">Proveedor</th>
              <!-- <th scope="col">Opciones</th> -->
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let mov of listaMaquinas; let i = index" (click)="ClickedRow(i, mov)"
              [class.active]="mov.numero_placa == getPlacaSeleccionada()">
              <td>
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="showModalVerMovimiento(mov)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td>{{mov.numero_placa}}</td>
              <td>{{mov.nombre}}</td>
              <td>{{mov.modelo}}</td>
              <td>{{mov.fecha_compra | fecha}}</td>
              <td *ngIf="mov.ubicacion === 'CENTRO DE DISTRIBUCIÓN   '">CENTRO DISTRIBUCIÓN</td>
              <td *ngIf="mov.ubicacion != 'CENTRO DE DISTRIBUCIÓN   '">{{mov.ubicacion}}</td>
              <td>
                <span
                  *ngIf="mov.ubicacion === 'CENTRO DE DISTRIBUCIÓN   ' && mov.cliente_proveedor_rut === 0 || mov.cliente_proveedor_rut === null">
                </span>
                <span
                  *ngIf="mov.ubicacion != 'CENTRO DE DISTRIBUCIÓN   ' && mov.cliente_proveedor_rut != null && mov.cliente_proveedor_rut > 0">
                  {{this.rutService.AgregarDV(mov.cliente_proveedor_rut) | rut}}</span>
              </td>
              <td>
                <span *ngIf="mov.ubicacion === 'CENTRO DE DISTRIBUCIÓN   ' "></span>
                <span *ngIf="mov.ubicacion != 'CENTRO DE DISTRIBUCIÓN   ' ">{{mov.nombre_cliente}}</span>
                <!-- <span  *ngIf="mov.tipo_destinatario_codigo != 2"></span> -->
              </td>
              <!-- <td>{{mov.sucursal_codigo}}</td>
              <td>{{mov.nombre_sucursal}}</td> -->
              <td>
                <span *ngIf="mov.tipo_destinatario_codigo === 2">{{mov.direccion}}</span>
                <span *ngIf="mov.tipo_destinatario_codigo != 2"></span>
              </td>
              <td>
                <span *ngIf="mov.tipo_destinatario_codigo === 2">{{mov.nombre_comuna}}</span>
                <span *ngIf="mov.tipo_destinatario_codigo != 2"></span>
              </td>
              <td>
                <span *ngIf="mov.codigo_vendedor != 0">{{mov.codigo_vendedor}}</span>
              </td>
              <td>{{mov.nombre_vendedor}}</td>
              <td>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 1" pill="true" success="true">
                  {{mov.estado_maquina_nombre}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 2" pill="true" info="true">{{mov.estado_maquina_nombre}}
                </mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 3" pill="true" warning="true">
                  {{mov.estado_maquina_nombre}}</mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 4" pill="true"
                  danger="true">{{mov.estado_maquina_nombre}}
                </mdb-badge>
                <mdb-badge *ngIf="mov.estado_maquina_codigo === 0" pill="true"
                  danger="true">{{mov.estado_maquina_nombre}}
                </mdb-badge>
              </td>
              <td>{{mov.proveedor_nombre}}</td>
            </tr>
            <tr>
              <td colspan="100%" style="text-align: center">
                <div class="row pb-1 pt-1" id="spinnerX">
                  <div class="col-md-12 p-4">
                    <ngx-spinner bdColor="" bdoOpacity="0.9" size="default" color="#581f87" type="ball-pulse-sync"
                      [fullScreen]="false">
                    </ngx-spinner>

                  </div>
                </div>
              </td>

            </tr>
          </tbody>
          <tfoot *ngIf="listaMaquinas?.length > 0">
            <tr>
              <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
              <th colspan="12">
                {{ PagPosActual }} de {{ totalPagPos }} ({{
                totalRegistrosPos
                }}
                registros)
              </th>
            </tr>
          </tfoot>
          <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMaquinas?.length > 0"></app-pagination> -->
        </table>
      </div>
    </div>
  </div>
</section>


<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL agregarMaquina -->
<app-maquinas-maestro-modal-add-edit mode="ADD" (onSuccess)="buscar(1)">
</app-maquinas-maestro-modal-add-edit>

<!-- MODAL editarMaquina -->
<app-maquinas-maestro-modal-add-edit mode="EDIT" (onSuccess)="buscar(1)"
  (onEditRowButtons)="ObtenerEstadoMaquina($event)">
</app-maquinas-maestro-modal-add-edit>

<!-- MODAL asignarMaquina -->
<app-maquinas-maestro-modal-asignar (onSuccess)="DespuesAsignarbuscar(1)">
</app-maquinas-maestro-modal-asignar>

<!-- MODAL darDeBaja -->
<app-maquinas-maestro-modal-dar-de-baja (onSuccess)="buscar(1)" (onEnableButtons)="EnableAsignAndInact()">
</app-maquinas-maestro-modal-dar-de-baja>

<!-- MODAL cargaMasiva -->
 <app-modal-carga-masiva></app-modal-carga-masiva>
<!-- <app-maquinas-maestro-modal-carga-masiva>
</app-maquinas-maestro-modal-carga-masiva> -->

<!-- MODAL verMovimiento -->
<app-maquinas-maestro-modal-ver-movimiento>
</app-maquinas-maestro-modal-ver-movimiento>

<!-- Confirm Delete -->
<app-modal-confirm title="Eliminar máquina" contentText="¿Desea eliminar la máquina?">
</app-modal-confirm>